import { ConductorOneChildActive, Router } from "@frui.ts/screens";
import { action, computed, observable } from "mobx";
import { Modules } from "config";
import LocalizationService from "services/localizationService";
import SubLedgerListViewModel from "./SubLedgerListViewModel";
import SubLedgerNewReportViewModel from "./SubLedgerNewReportViewModel";

const navigationName = "subledger";

@Router.registerRoute({
  name: Router.Self,
  route: navigationName,
  children: [SubLedgerListViewModel, SubLedgerNewReportViewModel],
})
export default class SubLedgerViewModel extends ConductorOneChildActive<SubLedgerListViewModel | SubLedgerNewReportViewModel> {
  @observable isList = true;

  constructor(
    public subLedgerListViewModel: SubLedgerListViewModel,
    public subLedgerNewReportViewModel: SubLedgerNewReportViewModel,
    private localizationService: LocalizationService
  ) {
    super();
    subLedgerListViewModel.onNewReportClick = () => this.showNewReport();
    subLedgerNewReportViewModel.onCloseClick = () => this.showList();

    this.navigationName = navigationName;
    this.children.push(this.subLedgerListViewModel, this.subLedgerNewReportViewModel);
  }

  protected onInitialize(): Promise<any> | void {
    this.tryActivateChild(this.children[0]);
    return super.onInitialize();
  }

  @action.bound
  showNewReport() {
    this.isList = false;
    void this.tryActivateChild(this.subLedgerNewReportViewModel);
  }

  @action.bound
  showList() {
    this.isList = true;
    void this.tryActivateChild(this.subLedgerListViewModel);
  }

  @computed
  get name() {
    return this.translate("name");
  }

  translate(code: string, size?: number) {
    return this.localizationService.translateModule(Modules.finance, `subLedger.${code}`, size);
  }
}
